module.exports = __webpack_public_path__ + "img/enter-values.f4a6b9a9.gif";